// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"f8922b83","122":"cfded6e0","138":"04c78c07","145":"dcb0373f","165":"d3fa0370","211":"d494cae2","225":"b22ddde8","259":"26356271","315":"c4aa4543","453":"93951591","669":"e4e28f79","804":"7cf9a7a0"}[chunkId] + ".chunk.js";
};